import React from 'react'

const SuccessPage = () => {
  return <div className='success-page'>Перевод выполнен успешно</div>
}

export default SuccessPage
